<div class="card shadow-sm mb-5">
  <div class="card-header text-white">
    <h3 class="mb-0"><i class="fa fa-money-check-alt"></i> Histórico de Transferencias</h3>
  </div>

  <div class="card-body">
    <!-- Filtros -->
    <div class="card p-3 mb-4 shadow-sm">
      <h5><i class="fa fa-filter"></i> Filtrar</h5>
      <div class="row g-3 align-items-end mt-2">
        <!-- Fecha inicio -->
        <div class="col-sm-6">
          <label for="startDate" class="form-label">Fecha inicio</label>
          <input type="date" id="startDate" [(ngModel)]="startDate" class="form-control" />
        </div>

        <!-- Fecha fin -->
        <div class="col-sm-6">
          <label for="endDate" class="form-label">Fecha final</label>
          <input type="date" id="endDate" [(ngModel)]="endDate" class="form-control" />
        </div>

        <div class="col-sm-6">
          <label for="filterAccount" class="form-label">Cuenta</label>
          <input type="text"
                id="filterAccount"
                [(ngModel)]="accountFilter"
                class="form-control"
                placeholder="Cuenta origen o destino"
                (keyup.enter)="updateFilter()" />
        </div>

        <!-- Botón buscar -->
        <div class="col-sm-6">
          <button class="btn btn-primary w-100" (click)="getTransfers()">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Cuenta Origen</th>
            <th>Cuenta Destino</th>
            <th>Monto</th>
            <th>Estado</th>
            <th>Fechas</th>
            <th>Descripción</th>
            <th>Autorización</th>
            <th>Error</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let transfer of pagination.filter">
            <tr [class.table-danger]="transfer.transactionStatus === 'FAILED'">

              <!-- Cuenta Origen -->
              <td>
                <div class="fw-bold">{{ transfer.sourceAccountNumber }}</div>
                <small class="text-muted">
                  {{ transfer.sourceBankName }} ({{ transfer.sourceAccountType }})
                </small>
              </td>

              <!-- Cuenta Destino -->
              <td>
                <div class="fw-bold">{{ transfer.destinationAccountNumber }}</div>
                <small class="text-muted">
                  {{ transfer.destinationBankName }} ({{ transfer.destinationAccountType }})
                </small>
              </td>

              <!-- Monto -->
              <td class="fw-bold text-end">
                {{ transfer.amount | currency:'Q' }}
              </td>

              <!-- Estado -->
              <td>
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-warning text-dark': transfer.transactionStatus === 'PENDING',
                    'bg-info text-dark': transfer.transactionStatus === 'SUCCESS',
                    'bg-success': transfer.transactionStatus === 'ACCEPTED',
                    'bg-danger': transfer.transactionStatus === 'FAILED',
                    'bg-secondary': transfer.transactionStatus === 'TIMEOUT'
                  }"
                >
                  <i class="fa"
                    [ngClass]="{
                      'fa-hourglass-half': transfer.transactionStatus === 'PENDING',
                      'fa-check-circle': transfer.transactionStatus === 'SUCCESS',
                      'fa-thumbs-up': transfer.transactionStatus === 'ACCEPTED',
                      'fa-times-circle': transfer.transactionStatus === 'FAILED',
                      'fa-clock': transfer.transactionStatus === 'TIMEOUT'
                    }"
                  ></i>
                  <ng-container [ngSwitch]="transfer.transactionStatus">
                    <span *ngSwitchCase="'PENDING'"> Pendiente</span>
                    <span *ngSwitchCase="'SUCCESS'"> Éxito (falta aprobación)</span>
                    <span *ngSwitchCase="'ACCEPTED'"> Aceptado</span>
                    <span *ngSwitchCase="'FAILED'"> Fallido</span>
                    <span *ngSwitchCase="'TIMEOUT'"> Tiempo excedido</span>
                    <span *ngSwitchDefault>{{ transfer.transactionStatus }}</span>
                  </ng-container>
                </span>
              </td>

              <!-- Fechas -->
              <td>
                <div>
                    <strong>{{ formatCreatedAt(transfer.createdAt) }}</strong>
                    <div class="small text-muted">Creación</div>
                </div>
              </td>

              <!-- Descripcion -->
              <td>
                <span
                  *ngIf="transfer.description; else noDescription"
                  class="d-inline-block"
                  style="max-width: 250px; white-space: normal; word-break: break-word;"
                  [title]="transfer.description"
                >
                  {{ transfer.description }}
                </span>
                <ng-template #noDescription>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <!-- Autorizacion -->
              <td>
                <span *ngIf="transfer.authorization; else noAuthorization" class="fw-bold">
                  {{ transfer.authorization }}
                </span>

                <ng-template #noAuthorization>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

              <!-- Error -->
              <td>
                <span
                  *ngIf="transfer.errorMessage; else noError"
                  class="text-danger d-inline-block"
                  style="max-width: 250px; white-space: normal; word-break: break-word;"
                  [title]="transfer.errorMessage"
                >
                  {{ transfer.errorMessage }}
                </span>
                <ng-template #noError>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>

            <!-- Acciones -->
            <td class="text-center">
              <span
                *ngIf="transfer.authorization"
                (click)="downloadAcceptancePdf(transfer)"
                title="Descargar PDF"
                class="clickeable text-info"
              >
                <i
                  *ngIf="!loadingDownload[transfer.id]"
                  class="fa-solid fa-download"
                ></i>

                <span
                  *ngIf="loadingDownload[transfer.id]"
                  class="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
              </span>
            </td>
            </tr>
          </ng-container>

          <!-- Sin resultados -->
          <tr *ngIf="pagination.filter.length === 0">
            <td colspan="9" class="text-center text-muted">
              <i class="fa fa-circle-info"></i> No se encontraron transferencias en el rango seleccionado
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
  </div>
</div>
